<template>
  <div class="qx-data-board">
    <!-- 头部内容 -->
    <div class="qx-data-board-top">
      <div class="top-btn">
        <div class="btn">领导驾驶舱</div>
        <div class="btn">教育全景</div>
        <div class="btn">智能教学</div>
      </div>
      <div class="top-time">
        <div class="time">{{ currentTime }}</div>
        <div class="date">{{ date }}</div>
      </div>
      <div class="top-select-btn">
        <!-- <div class="">全部</div> -->
        <div class="left-btn">
          <div class="btn" :class="selectType == 'all' ? 'is-select' : ''" @click="changeSelectType('all')">全部</div>
          <div class="btn" :class="selectType == 'month' ? 'is-select' : ''" @click="changeSelectType('month')">本月</div>
          <div class="btn" :class="selectType == 'semester' ? 'is-select' : ''" @click="changeSelectType('semester')">本学期
          </div>
          <div class="btn" :class="selectType == 'custom' ? 'is-select' : ''" @click="changeSelectType('custom')">自定义
          </div>
        </div>
        <div v-if="selectType == 'custom'" class="custom-select">
          <el-date-picker popper-class="qx-data-board-custom-data-picker" class="custom-date-picker" v-model="dateValue"
            type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="changeDateTime" style="margin-right:15px;">
          </el-date-picker>
        </div>
        <div class="select-right">
          <el-select v-model="areaId" style="width:120px" popper-class="select-option" :popper-append-to-body="false"
            @change="changeArea">
            <el-option v-for="item in areaList" class="option-item" :key="item.value" :value="item.value"
              :label="item.address"></el-option>
          </el-select>
          <el-select v-model="schoolId" style="width:120px;margin-left: 15px;" popper-class="qx-data-board-school-select"
            :popper-append-to-body="true">
            <el-option v-for="item in schoolList" class="option-item" :key="item.schoolId" :value="item.schoolId"
              :label="item.schoolName"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="qx-data-board-content">
      <!-- 左侧内容 -->
      <div class="qx-data-board-left">
        <teacher-week-chart :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
          :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId"></teacher-week-chart>
        <school-activity-ranking :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
          :districtId="districtId" :cityId="cityId" :address="areaId" :startTime="startTime"
          :endTime="endTime"></school-activity-ranking>
        <school-use-app :regionId="regionId" :regionType="regionType" :provinceId="provinceId" :districtId="districtId"
          :cityId="cityId" :address="areaId" :startTime="startTime" :endTime="endTime"></school-use-app>
      </div>
      <!-- 右侧内容 -->
      <div class="qx-data-board-center">
        <resource-center :regionId="regionId" :regionType="regionType" :provinceId="provinceId" :districtId="districtId"
          :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime"
          :endTime="endTime"></resource-center>
        <div class="studio-answer">
          <div class="left">
            <teaching-studio :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
              :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime"
              :endTime="endTime"></teaching-studio>
            <collective-lesson :regionId="regionId" :regionType="regionType" :regionName="regionName"
              :regionJtbkNum="regionJtbkNum" :regionJtbkJoinNum="regionJtbkJoinNum" :provinceId="provinceId"
              :districtId="districtId" :cityId="cityId" :address="areaId" :startTime="startTime" :endTime="endTime"
              :jtbkNum="jtbkNum"></collective-lesson>
          </div>
          <div class="right">
            <answer-question :regionId="regionId" :provinceId="provinceId" :regionType="regionType"
              :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime"
              :endTime="endTime"></answer-question>
            <activity-appraise :regionId="regionId" :regionType="regionType" :provinceId="provinceId"
              :districtId="districtId" :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime"
              :endTime="endTime" :hdpxNum="hdpxNum"></activity-appraise>
          </div>
        </div>
      </div>
      <div class="qx-data-board-right">
        <listen-lesson :regionId="regionId" :regionType="regionType" :regionName="regionName" :regionTpkNum="regionTpkNum"
          :regionTpkJoinNum="regionTpkJoinNum" :provinceId="provinceId" :districtId="districtId" :cityId="cityId"
          :address="areaId" :startTime="startTime" :endTime="endTime" :pkbNum="pkbNum" :tpkNum="tpkNum"></listen-lesson>
        <online-courses :regionId="regionId" :regionType="regionType" :provinceId="provinceId" :districtId="districtId"
          :cityId="cityId" :address="areaId" :schoolId="schoolId" :startTime="startTime" :endTime="endTime"
          :zxkcNum="zxkcNum"></online-courses>
      </div>
    </div>
  </div>
</template>

<script>
import TeacherWeekChart from "./modules/TeacherWeekChart.vue"
import SchoolActivityRanking from "./modules/SchoolActivityRanking.vue"
import SchoolUseApp from "./modules/SchUseAppProportion.vue"
import ResourceCenter from "./modules/ResourceCenter.vue"
import TeachingStudio from "./modules/TeachingStudio.vue"
import OnlineCourses from "./modules/OnlineCourses.vue"
import ActivityAppraise from "./modules/ActivityAppraise.vue"
import CollectiveLesson from "./modules/CollectiveLesson.vue"
import ListenLesson from "./modules/ListenLesson.vue"
import AnswerQuestion from "./modules/AnswerQuestion.vue"
import ExamineBigData from "./modules/ExamineBigData.vue"
import { getNextRegionSchoolInfomation, getDistrictSchoolList, getPlatFormInfoByPlatformDomainAPI, getPlatformStatAPI } from "@/service/api"
export default {
  name: 'qx-data-board',
  components: {
    TeacherWeekChart,
    SchoolActivityRanking,
    SchoolUseApp,
    ResourceCenter,
    TeachingStudio,
    OnlineCourses,
    ActivityAppraise,
    CollectiveLesson,
    ListenLesson,
    AnswerQuestion,
    ExamineBigData
  },
  data() {
    return {
      dateValue: '',
      selectType: "all",
      timeInterval: null,
      currentTime: "",
      date: '',
      areaId: "",
      //地区列表
      areaList: [
        {
          address: "全部区域",
          value: ""
        }
      ],
      schoolId: "",
      schoolList: [
        {
          schoolId: "",
          schoolName: "全部学校"
        }
      ],
      cityId: "140100",
      districtId: "140121",
      provinceId: "140000",
      regionId: "c5c29d5be731480c98abbfcc9b0fa43b",
      //平台类型
      regionType: "3",
      //平台名称
      regionName: "清徐县教育云平台",
      startTime: "",
      endTime: "",
      //集体备课数量
      jtbkNum: 0,
      //活动评选数量
      hdpxNum: 0,
      //听评课评课表数量
      pkbNum: 0,
      //听评课数量
      tpkNum: 0,
      //在线课程数量
      zxkcNum: 0,
      //教师总数
      teacherNum: 0,
      //局端集体备课数量
      regionJtbkNum: 0,
      //局端听评课数量
      regionTpkNum: 0,
      //局端听评课参加人数
      regionTpkJoinNum: 0,
      //局端集体备课参加人数
      regionJtbkJoinNum: 0,
    }
  },
  methods: {
    /**
     * @name 切换区域
     */
    changeArea() {
      this.schoolId = ''
      this.schoolList = [];
      this.getSchoolList();
      this.getPlatformStat();
    },
    /**
     * @name 切换筛选类型
     */
    changeSelectType(type) {
      if (this.selectType == type) {
        return
      }
      this.selectType = type;
      if (type == 'all') {
        this.startTime = "";
        this.endTime = ""
      } else if (type == 'month') {
        this.startTime = this.$utils.getMonthStartDate();
        this.endTime = this.$utils.getMonthEndDate();
      } else if (type == 'semester') {
        //判断当前日期是在学年的前半段还是后半段
        let year = new Date().getFullYear();
        //当前时间大于学年开始时间，则处于学年的后半段
        if (new Date().getTime() < new Date(`${year}-08-10 00:00:00`).getTime()) {
          this.startTime = `${year}-02-01`;
          this.endTime = `${year}-08-09`
        } else {
          this.startTime = `${year}-08-10`;
          this.endTime = `${year + 1}-01-31`
        }
      }
      this.getPlatformStat();
    },
    /**
     * @name 切换时间
     */
    changeDateTime(date) {
      if (date) {
        this.startTime = date[0];
        this.endTime = date[1]
      } else {
        this.startTime = '';
        this.endTime = '';
      }
      this.getPlatformStat();
    },
    /**
     * @name 获取时间
     */
    getTime() {
      const now = new Date();
      const year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = now.getDate();
      day = day < 10 ? '0' + day : day;
      let hour = now.getHours();
      hour = hour < 10 ? '0' + hour : hour;
      let minute = now.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      let second = now.getSeconds();
      second = second < 10 ? '0' + second : second;
      this.date = `${year}年${month}月${day}日`
      this.currentTime = `${hour}:${minute}:${second}`
    },
    /**
     * @name 获取省市区下的镇
     */
    getTownlet() {
      let params = {
        provinceCode: this.provinceId,
        cityCode: this.cityId,
        districtCode: this.districtId,
        isTowns: 1
      }
      getNextRegionSchoolInfomation(params).then((res) => {
        this.areaList = res.map((item) => {
          return {
            ...item,
            value: item.address
          }
        })
        this.areaList.unshift({
          value: "",
          address: '全部区域'
        })
      }).catch((err) => {
      })
    },
    /**
     * @name 获取学校列表
     */
    getSchoolList() {
      let params = {
        province: this.provinceId,
        city: this.cityId,
        districtId: this.districtId,
        page: 1,
        limit: 100,
        keyWord: "",
        isTowns: 1,
        address: this.areaId
      }
      getDistrictSchoolList(params).then((res) => {
        this.schoolList = res.classCountList.map((item) => {
          return {
            ...item,
            schoolId: item.id,
            schoolName: item.school_name
          }
        })
        this.schoolList.unshift({
          schoolId: '',
          schoolName: '全部学校'
        })
      }).catch((err) => {

      })
    },
    /**
     * @name 根据域名获取区域信息
     */
    getRegionByDomain() {
      let params = {
        platformDomain: "www.qxzhjy.cn"
      }
      getPlatFormInfoByPlatformDomainAPI(params).then((res) => {
        this.regionName = res.platformName;
        this.regionId = res.id;
        this.regionType = res.regionPlatformType;
        this.provinceId = res.region[0].provinceId;
        this.cityId = res.region[0].cityId;
        this.districtId = res.region[0].districtId;
        this.getPlatformStat();
      }).catch((err) => {
        this.getPlatformStat();
      })
    },
    /**
     * @name 获取平台统计
     */
    getPlatformStat() {
      let params = {
        regionId: this.regionId,
        startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
        endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
        provinceId: this.provinceId,
        cityId: this.cityId,
        districtId: this.districtId,
        address: this.areaId,
        regionType: this.regionType
      }
      getPlatformStatAPI(params).then((res) => {
        //集体备课数量
        this.jtbkNum = res.jtbkNum;
        //活动评选数量
        this.hdpxNum = res.hdpxNum;
        this.tpkNum = res.tpkNum;
        this.pkbNum = res.pkbNum;
        this.zxkcNum = res.zxkcNum;
        if (!this.areaId) {
          //局端集体备课数量
          this.regionJtbkNum = res.regionJtbkNum;
          //局端集体备课参加人数
          this.regionJtbkJoinNum = res.regionJtbkJoinNum;
          //局端听评课数量
          this.regionTpkNum = res.regionTpkNum;
          //局端听评课参加人数
          this.regionTpkJoinNum = res.regionTpkJoinNum;
        } else {
          //局端集体备课数量
          this.regionJtbkNum = 0;
          //局端集体备课参加人数
          this.regionJtbkJoinNum = 0;
          //局端听评课数量
          this.regionTpkNum = 0;
          //局端听评课参加人数
          this.regionTpkJoinNum = 0;
        }
      }).catch((err) => { })
    },

  },
  mounted() {
    this.timeInterval = setInterval(() => {
      this.getTime()
    }, 1000);
    //获取省市区下的镇
    this.getTownlet();
    //获取省市区下的学校
    this.getSchoolList();
    //通过域名获取区域
    this.getRegionByDomain();
  }
}
</script>

<style lang="scss" scoped>
.qx-data-board {
  background: url("~@/assets/images/qxdataboard/bg.png") no-repeat;
  background-size: 100% 100%;

  .qx-data-board-top {
    height: 140px;
    width: 100%;
    background: url("~@/assets/images/qxdataboard/top-bg.png") no-repeat;
    background-size: 100% auto;
    position: relative;

    .top-btn {
      position: absolute;
      top: 7px;
      left: 920px;
      display: flex;
      align-items: center;
      color: #fff;
      display: none;

      .btn {
        width: 150px;
        height: 40px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C1ECFF;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("~@/assets/images/qxdataboard/btn-bg.png");
        background-size: 100% 100%;

        &:hover {
          background: url("~@/assets/images/qxdataboard/btn-hover-bg.png");
          background-size: 100% 100%;
        }
      }
    }

    .top-time {
      position: absolute;
      top: 10px;
      right: 40px;
      color: #fff;
      display: flex;
      align-items: center;
      letter-spacing: -0.4px;

      .time {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #C1ECFF;
      }

      .date {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7B9DAD;
        margin-left: 5px;
      }
    }

    .top-select-btn {
      position: absolute;
      bottom: 10px;
      right: 30px;
      display: flex;
      align-items: center;

      .left-btn {
        width: 280px;
        height: 36px;
        background: rgba(31, 51, 141, 0.57);
        border-radius: 4px;
        display: flex;
        align-items: center;
        margin-right: 20px;
        padding: 2px;

        .btn {
          padding: 9px 16px;
          margin-right: 5px;
          background: transparent;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #C1ECFF;
          white-space: nowrap;
          cursor: pointer;
        }

        .is-select {
          background: linear-gradient(0deg, #177BC1 0%, #20B8CE 100%);
          border-radius: 4px;
        }
      }
    }

  }

  .qx-data-board-content {
    width: 100%;
    padding: 0 20px 20px;
    display: flex;
    // background-image:,
    // background-image: url("~@/library/ui/mk-share-res/assets/unfold.png");

    .qx-data-board-left {
      width: calc(25% - 15px);
      margin-right: 20px;
    }

    .qx-data-board-center {
      width: calc(50% - 15px);
      margin-right: 25px;

      .studio-answer {
        display: flex;
        align-items: center;

        .left {
          width: calc(60% - 10px);
          margin-right: 20px;
        }

        .right {
          width: calc(40% - 10px);
        }
      }
    }

    .qx-data-board-right {
      width: calc(25% - 15px);
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
    }
  }
}
</style>

<style lang="scss">
.qx-data-board {
  .qx-data-board-top {
    .top-select-btn {
      .select-right {
        .el-select {
          .el-input {
            .el-input__inner {
              background-color: rgba(31, 51, 141, 0.57);
              border-color: rgba(31, 51, 141, 0.57);
              color: #C1ECFF;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                i {
                  color: #C1ECFF
                }
              }
            }
          }
        }

        .select-option {
          background-color: #1F338D;
          border-color: #1F338D;

          .popper__arrow {
            display: none;
          }

          .popper__arrow {
            border-color: #1F338D;
          }

          .option-item {
            background-color: #1F338D;
            color: #fff;
          }

          .selected {
            color: #20B8CE;
          }
        }
      }

      .custom-select {
        .custom-date-picker {
          width: 270px;
          background-color: #1F338D;
          border-color: #1F338D;
          color: #C1ECFF;

          .el-range-input {
            background-color: #1F338D;
            border-color: #1F338D;
            color: #C1ECFF;
          }

          .el-range-separator {
            padding: 0;
            color: #C1ECFF;
          }
        }
      }
    }
  }
}

.qx-data-board-school-select {
  background-color: #1F338D;
  border-color: #1F338D;

  .popper__arrow {
    display: none;
  }

  .popper__arrow {
    border-color: #1F338D;
  }

  .option-item {
    background-color: #1F338D;
    color: #fff;
  }

  .selected {
    color: #20B8CE;
  }
}

.qx-data-board-custom-data-picker {
  background: #1F338D;
  border-color: #1F338D;

  .el-date-range-picker__header {
    color: #fff;

    .el-picker-panel__icon-btn {
      color: #fff;
    }
  }

  .el-date-table {
    color: #fff;

    th {
      color: #fff
    }
  }

  .el-date-table td.in-range div,
  .el-date-table td.in-range div:hover,
  .el-date-table.is-week-mode .el-date-table__row.current div,
  .el-date-table.is-week-mode .el-date-table__row:hover div {
    background-color: #20B8CE;
  }

  .popper__arrow {
    display: none;
  }
}</style>